var render = function render() {
  var _setup$user$loyalty, _setup$user$loyalty2, _setup$user$loyalty3, _setup$user$loyalty4;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _setup.user && !_setup.isAggregator ? _c('li', {
    class: _vm.$style.listItem
  }, [_c('NuxtLink', {
    class: _vm.$style.itemLink,
    attrs: {
      "to": _setup.ROUTE_PATHS.loyaltyProgram
    },
    nativeOn: {
      "click": function click($event) {
        return _setup.emit('click');
      }
    }
  }, [(_setup$user$loyalty = _setup.user.loyalty) !== null && _setup$user$loyalty !== void 0 && (_setup$user$loyalty = _setup$user$loyalty.levelIcon) !== null && _setup$user$loyalty !== void 0 && _setup$user$loyalty.aws ? _c(_setup.SImageLazy, {
    class: _vm.$style.icon,
    attrs: {
      "src": _setup.user.loyalty.levelIcon.aws,
      "alt": "",
      "object-fit": "contain",
      "fade": ""
    }
  }) : _c(_setup.SIcon, {
    attrs: {
      "icon": "i-crownOutline",
      "size": "24"
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.$style.inlineVertical
  }, [_c('span', [_vm._v("Программа лояльности")]), _vm._v(" "), _c('span', {
    class: _vm.$style.levelLabel
  }, [_vm._v(_vm._s((_setup$user$loyalty2 = _setup.user.loyalty) === null || _setup$user$loyalty2 === void 0 ? void 0 : _setup$user$loyalty2.label))])]), _vm._v(" "), (_setup$user$loyalty3 = _setup.user.loyalty) !== null && _setup$user$loyalty3 !== void 0 && _setup$user$loyalty3.point ? _c('ScoreLabel', {
    attrs: {
      "value": _setup.user.loyalty.point,
      "size": "small"
    }
  }) : _vm._e()], 1), _vm._v(" "), _setup.isShowDayDowngradeStatus ? _c('div', {
    class: _vm.$style.itemContent
  }, [_c('div', {
    class: _vm.$style.icon
  }), _vm._v(" "), _c(_setup.StatusDowngradeTimer, {
    attrs: {
      "date": (_setup$user$loyalty4 = _setup.user.loyalty) === null || _setup$user$loyalty4 === void 0 ? void 0 : _setup$user$loyalty4.date_downgrade_status,
      "label": "до понижения статуса"
    }
  })], 1) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };